import styled from 'styled-components';

export const ImpersonationBannerStyled = styled.div`
    position: sticky;
    top: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    background: #c62828;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;

    button {
        flex-shrink: 0;
        font-weight: 700;
    }
`;
